/* Predictive search.
   2026-09-28: vorige verzoeken worden afgebroken zodat een oud (trager) antwoord nooit een nieuwer
   resultaat overschrijft, er wordt pas gezocht vanaf 2 tekens, en de resultaten verschijnen alleen
   zolang het Visser-zoekpaneel open staat. */
class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('#predictive-search');
    this.box = this.closest('.vc-hsearch');
    this.controller = null;
    this.lastTerm = '';

    if (!this.input || !this.predictiveSearchResults) return;

    this.input.addEventListener('input', this.debounce(() => {
      this.onChange();
    }, 220));
    this.input.addEventListener('focus', () => {
      if (this.input.value.trim().length >= 2 && this.predictiveSearchResults.innerHTML.trim().length && this.isPanelOpen()) this.open();
    });
  }

  isPanelOpen() {
    return !this.box || this.box.classList.contains('is-open');
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (searchTerm.length < 2) {
      if (this.controller) this.controller.abort();
      this.lastTerm = '';
      this.setLoading(false);
      this.close();
      return;
    }
    if (searchTerm === this.lastTerm) return;

    this.getSearchResults(searchTerm);
  }

  setLoading(on) {
    if (this.box) this.box.classList.toggle('is-loading', on);
  }

  getSearchResults(searchTerm) {
    if (this.controller) this.controller.abort();
    this.controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    this.lastTerm = searchTerm;
    this.setLoading(true);

    fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&resources[limit_scope]=each&section_id=predictive-search`, this.controller ? { signal: this.controller.signal } : {})
      .then((response) => {
        if (!response.ok) throw new Error(response.status);
        return response.text();
      })
      .then((text) => {
        if (searchTerm !== this.input.value.trim()) return;
        const section = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search');
        this.predictiveSearchResults.innerHTML = section ? section.innerHTML : '';
        this.predictiveSearchResults.scrollTop = 0;
        this.setLoading(false);
        if (this.isPanelOpen()) this.open();
      })
      .catch((error) => {
        if (error && error.name === 'AbortError') return;
        this.setLoading(false);
        this.lastTerm = '';
        this.close();
      });
  }

  open() {
    this.predictiveSearchResults.style.display = 'block';
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);
